/* TPV product info tabs.
   The markup is a stack of native <details> accordions, which is exactly what
   phones show — no JavaScript needed there. On desktop this script builds a
   real tab bar (role=tablist, aria-selected, arrow keys) from those panels
   and swaps them like tabs. */
(function () {
	var DESKTOP = window.matchMedia('(min-width: 992px)');

	function init(root) {
		if (root.dataset.tpvReady === 'true') return;
		root.dataset.tpvReady = 'true';

		var bar = root.querySelector('[data-tpv-tabbar]');
		var panels = Array.prototype.slice.call(root.querySelectorAll('[data-tpv-panel]'));
		if (!bar || panels.length === 0) return;

		var tabs = panels.map(function (panel, i) {
			var label = panel.querySelector('.tpv-ptabs__summary span');
			var btn = document.createElement('button');
			btn.type = 'button';
			btn.className = 'tpv-ptabs__tab';
			btn.setAttribute('role', 'tab');
			btn.id = 'tpv-tab-' + (panel.dataset.tpvPanelId || i);
			btn.textContent = label ? label.textContent : 'Tab ' + (i + 1);
			bar.appendChild(btn);
			var body = panel.querySelector('.tpv-ptabs__body');
			if (body) body.setAttribute('aria-labelledby', btn.id);
			return btn;
		});

		var current = 0;

		function select(i, focus) {
			current = (i + tabs.length) % tabs.length;
			tabs.forEach(function (t, j) {
				var active = j === current;
				t.setAttribute('aria-selected', active ? 'true' : 'false');
				t.tabIndex = active ? 0 : -1;
			});
			panels.forEach(function (p, j) {
				p.classList.toggle('tpv-ptabs__panel--active', j === current);
				if (DESKTOP.matches) p.open = true; /* body visibility is CSS-driven on desktop */
			});
			if (focus) tabs[current].focus();
		}

		tabs.forEach(function (t, i) {
			t.addEventListener('click', function () { select(i); });
			t.addEventListener('keydown', function (e) {
				if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); select(current + 1, true); }
				if (e.key === 'ArrowLeft' || e.key === 'ArrowUp')    { e.preventDefault(); select(current - 1, true); }
				if (e.key === 'Home') { e.preventDefault(); select(0, true); }
				if (e.key === 'End')  { e.preventDefault(); select(tabs.length - 1, true); }
			});
		});

		function apply() {
			if (DESKTOP.matches) {
				bar.hidden = false;
				root.classList.add('tpv-ptabs--tabbed');
				panels.forEach(function (p) { p.open = true; });
				select(current);
			} else {
				bar.hidden = true;
				root.classList.remove('tpv-ptabs--tabbed');
				panels.forEach(function (p, j) { p.open = j === 0; });
			}
		}

		apply();
		if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', apply);
		else DESKTOP.addListener(apply);
	}

	function boot(scope) {
		(scope || document).querySelectorAll('[data-tpv-ptabs]').forEach(init);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { boot(); });
	} else {
		boot();
	}
	document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
